import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './components/common/Header';
import Spinner from './components/common/Spinner';
import Home from './components/pages/Home';
import About from './components/pages/About';
import Contact from './components/pages/Contact';
import DonationSuccess from '../src/components/pages/DonationSuccess'
import DonationCancel from '../src/components/pages/DonationCancel'
import Donate from '../src/components/pages/Donate'

import Events from './components/pages/Events';
import { initAnimations } from './utils/animations';
import './assets/css/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ScrollToTop from './components/common/ScrollToTop';

function App() {
  useEffect(() => {
    initAnimations();
  }, []);

  return (
    <Router>
      <ScrollToTop />

      <div className="App">
        <Spinner />
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/donation-success" element={<DonationSuccess />} />
          <Route path="/cancel" element={<DonationCancel />} />
          <Route path="/events" element={<Events />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;